import Page from 'components/ui/Page'
import { useCalendlyWindowEvents } from 'hooks/calendlyHooks'
import React from 'react'
import { useParams } from 'react-router-dom'
import ProviderView from './ProviderView'

const ProviderViewPage = () => {
    const { id, tab } = useParams()
    useCalendlyWindowEvents()

    return (
        <Page title="Providers">
            <ProviderView providerId={parseInt(id, 10)} tab={tab} />
        </Page>
    )
}

export default ProviderViewPage
